export function CustomerQuote(props) {
    return (
        <div
            className={`z-30 rounded-[3rem] lg:rounded-[5rem] xl:rounded-[7rem] py-16 px-12 lg:px-20 flex flex-col w-full justify-start items-center lg:flex-row lg:items-start mb-12 lg:mb-0 ${
                props.className ? props.className : ""
            }`}
        >
            <img
                className="w-48 h-48 mb-8 lg:mr-16 lg:mb-0"
                src={props.img}
                alt={props.customer ? `${props.customer} photo` : ""}
                loading="lazy"
            />
            <div className="text-base flex flex-col gap-4 font-regular">
                "{props.quote}"
                <span className="font-semibold">{props.customer}</span>
                {props.children}
            </div>
        </div>
    );
}
